import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        isLoggedIn: !!localStorage.getItem("token"),
        userData:{},
        result:{}
    },
    mutations: {
        loginUser(state, item) {
            state.isLoggedIn = item
        },
        userData(state, item) {
            state.userData = item
        },
        sessionOut(state) {
			localStorage.removeItem("token");
			state.isLoggedIn = false
		},
       searchData(state, item) {
            state.result= item
            console.log("s",state.result)
        },
    }

})